module.exports = __webpack_public_path__ + "img/1484669874.13dbbd87.jpg";